import React from 'react'
import { Button } from '@mui/material'
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined'
import { getDropinOnlyStatusText } from './activities/ViewHelper'

const DropinOnlyStatusButton: React.FC = () => {
  const color = '#455a64'
  const bg = '#eceff1'

  return (
    <Button
      variant="contained"
      disabled
      fullWidth
      startIcon={<ConfirmationNumberOutlinedIcon />}
      sx={{
        backgroundColor: bg,
        color: color,
        border: `1px solid ${color}`,
        fontWeight: 'bold',
        letterSpacing: 1,
        boxShadow: 'none',
        '& .MuiButton-startIcon': { color: color },
        '&:hover': {
          backgroundColor: bg,
          color: color,
          border: `1px solid ${color}`,
          boxShadow: 'none'
        },
        '&.Mui-disabled': {
          backgroundColor: bg,
          color: color,
          border: `1px solid ${color}`,
          opacity: 1
        }
      }}
    >
      {getDropinOnlyStatusText()}
    </Button>
  )
}

export default DropinOnlyStatusButton
